import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
  FieldTitle,
  RadioGroup,
  RadioGroupItem,
} from './ui'

export interface RadioCard<TValue extends string> {
  value: TValue
  title: string
  description: string
}

interface Props<TValue extends string> {
  className?: string
  id?: string

  value: TValue
  options: RadioCard<TValue>[]

  onChange(value: TValue): void
}

export function RadioCards<TValue extends string>({
  className,
  id,

  value,
  options,

  onChange,
}: Props<TValue>) {
  return (
    <RadioGroup
      className={className}
      id={id}
      value={value}
      onValueChange={onChange}
    >
      {options.map(card => (
        <FieldLabel key={card.value} className="ml-0" htmlFor={card.value}>
          <Field orientation="horizontal">
            <FieldContent>
              <FieldTitle>{card.title}</FieldTitle>

              <FieldDescription className="ml-0">
                {card.description}
              </FieldDescription>
            </FieldContent>

            <RadioGroupItem id={card.value} value={card.value} />
          </Field>
        </FieldLabel>
      ))}
    </RadioGroup>
  )
}
